var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-control custom-checkbox custom-control-inline" },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.internalValue,
            expression: "internalValue"
          }
        ],
        staticClass: "custom-control-input",
        attrs: { type: "checkbox", name: _vm.key, id: _vm.key },
        domProps: {
          checked: Array.isArray(_vm.internalValue)
            ? _vm._i(_vm.internalValue, null) > -1
            : _vm.internalValue
        },
        on: {
          change: [
            function($event) {
              var $$a = _vm.internalValue,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.internalValue = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.internalValue = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.internalValue = $$c
              }
            },
            _vm.onChange
          ]
        }
      }),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "custom-control-label", attrs: { for: _vm.key } },
        [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70a0895e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70a0895e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./_wwwsrc/js/ConventionServitude/Components/CheckboxInput.vue
// module id = 669
// module chunks = 0